module.exports = function() {
  return new Worker(__webpack_public_path__ + "d9032bb50ddc9856d7a2.worker.js");
};